console.log("menu-deroulant.js");

let usingKeyboard = false;

document.addEventListener('keydown', () => {
  usingKeyboard = true;
});

document.addEventListener('mousedown', () => {
  usingKeyboard = false;
});

document.addEventListener('click', function (e) {

  const toggle = e.target.closest('[data-menu-toggle]');

  // Clic sur un bouton de menu
if (toggle) {

  const menu = toggle.closest('[data-menu]');

  // si utilisation souris → aller à la page
  if (!usingKeyboard) {

    const seeMoreLink = menu.querySelector('.seemore a');

    if (seeMoreLink) {
      window.location.href = seeMoreLink.href;
    }

    return;
  }

  // sinon comportement clavier normal
  const isOpen = toggle.getAttribute('aria-expanded') === 'true';

  if (!isOpen) {

    document.querySelectorAll('[data-menu]').forEach(m => {
      if (m !== menu) closeMenu(m);
    });

    openMenu(menu);

  } else {

    closeMenu(menu);

  }

  return;
}

  // Clic extérieur
  if (!e.target.closest('[data-menu]')) {
    closeAllMenus();
  }

});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeAllMenus();
  }
});

function closeAllMenus() {
  document.querySelectorAll('[data-menu]').forEach(menu => closeMenu(menu));
}

function openMenu(menu) {

  const toggle = menu.querySelector('[data-menu-toggle]');
  const panel = menu.querySelector('[data-menu-panel]');

  toggle.setAttribute('aria-expanded', 'true');
  panel.hidden = false;

  requestAnimationFrame(() => {
    panel.classList.add('is-open');
  });

}

function closeMenu(menu) {

  const toggle = menu.querySelector('[data-menu-toggle]');
  const panel = menu.querySelector('[data-menu-panel]');

  toggle.setAttribute('aria-expanded', 'false');
  panel.classList.remove('is-open');
  panel.hidden = true;

}

// gestion du survol

let hoverTimeout;

document.querySelectorAll('[data-menu]').forEach(menu => {

  let hoverTimeout;

  menu.addEventListener('mouseenter', () => {
    clearTimeout(hoverTimeout);

    // Si le menu a été ouvert manuellement, ne pas le réouvrir
    if (!menu.classList.contains('manual-open')) {
      document.querySelectorAll('[data-menu]').forEach(m => {
        if (m !== menu) closeMenu(m);
      });
      openMenu(menu);
    }
  });

  menu.addEventListener('mouseleave', () => {
    hoverTimeout = setTimeout(() => {
      // Ne pas fermer si le menu est ouvert manuellement
      if (!menu.classList.contains('manual-open')) {
        closeMenu(menu);
      }
    }, 150);
  });

});